import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { FOOTER_COLUMNS } from "../../data/landingPageContent";
import { ButtonLink, HashLink, LOGO_SRC, WRAP } from "./ui";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden text-slate-300" style={{ background: "#04141A" }}>
      <div className={`${WRAP} relative pt-16 pb-8`}>
        <div className="grid gap-14 lg:grid-cols-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3.5">
              <span className="flex items-center justify-center p-2 bg-white rounded-xl">
                <img src={LOGO_SRC} alt="IZSoftwares logo" className="w-auto h-10" />
              </span>
              <span className="text-[26px] font-extrabold tracking-tight text-white">IZSales</span>
            </div>
            <p className="max-w-md mt-6 text-[15px] leading-relaxed text-slate-400">
              IZSales is a sales CRM that helps teams manage companies, pipelines, deals, tasks and conversations
              in one place.
            </p>
            <div className="flex flex-wrap gap-3 mt-7">
              <ButtonLink href="#features" variant="ghostLight" className="!h-11">
                Explore features
              </ButtonLink>
            </div>
          </div>

          {/* Link columns */}
          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-7">
            {FOOTER_COLUMNS.map((col) => (
              <div key={col.title}>
                <h4 className="pb-3 mb-5 text-[12px] font-bold tracking-[0.18em] uppercase text-white border-b border-white/10">
                  {col.title}
                </h4>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      {l.to ? (
                        <Link to={l.to} className="text-[14.5px] text-slate-400 transition-colors hover:text-cyan-300">
                          {l.label}
                        </Link>
                      ) : (
                        <HashLink href={l.href} className="text-[14.5px] text-slate-400 transition-colors hover:text-cyan-300">
                          {l.label}
                        </HashLink>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col items-center justify-between gap-4 pt-8 mt-14 text-[13px] border-t border-white/10 sm:flex-row text-slate-500">
          <p>© {new Date().getFullYear()} IZSoftwares. All rights reserved.</p>
          <a
            href="#top"
            className="inline-flex items-center gap-2 px-4 py-2 font-medium transition-colors border rounded-lg border-white/15 text-slate-300 hover:text-cyan-300 hover:border-cyan-400/40"
          >
            Back to top <ArrowUp size={14} />
          </a>
        </div>
      </div>
    </footer>
  );
}